import { render } from "./EventHistoryWidgetConfig.vue?vue&type=template&id=76a25336&scoped=true"
import script from "./EventHistoryWidgetConfig.vue?vue&type=script&lang=js"
export * from "./EventHistoryWidgetConfig.vue?vue&type=script&lang=js"

import "./EventHistoryWidgetConfig.vue?vue&type=style&index=0&id=76a25336&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a25336"],['__file',"src/containers/widget/configs/EventHistoryWidgetConfig.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76a25336"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76a25336', __exports__)) {
    api.reload('76a25336', __exports__)
  }
  
  module.hot.accept("./EventHistoryWidgetConfig.vue?vue&type=template&id=76a25336&scoped=true", () => {
    api.rerender('76a25336', render)
  })

}


export default __exports__